var React = require('react');

function PinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.1868 0.676758C15.1398 0.676758 18.356 3.89287 18.356 7.84591C18.356 12.8145 11.1798 21.3018 11.1798 21.3018C11.1798 21.3018 4.01765 12.5701 4.01765 7.84591C4.01765 3.89287 7.23364 0.676758 11.1868 0.676758ZM9.02372 9.94504C9.62017 10.5414 10.4034 10.8396 11.1868 10.8396C11.9701 10.8396 12.7536 10.5414 13.3498 9.94504C14.5425 8.75241 14.5425 6.81176 13.3498 5.619C12.7722 5.04119 12.0039 4.72295 11.1868 4.72295C10.3697 4.72295 9.60153 5.04132 9.02372 5.619C7.83096 6.81176 7.83096 8.75241 9.02372 9.94504Z","fill":"white"}));
}

PinInline.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = PinInline;

PinInline.default = PinInline;
